import { useState } from 'react'
import { useCrm } from '../ui'
import { CrmDialogHost, type CrmDialog } from './CrmDialogs'

/** Genel listelerde düzenleme/ekleme, kaydın ait olduğu müşteri bağlamında açılır. */
export function useScopedDialog() {
  const { customerById } = useCrm()
  const [state, setState] = useState<{ customerId: string; dialog: CrmDialog } | null>(null)
  const customer = state ? customerById.get(state.customerId) : undefined
  return {
    open: (customerId: string, dialog: CrmDialog) => setState({ customerId, dialog }),
    host: customer && state ? <CrmDialogHost dialog={state.dialog} customer={customer} onClose={() => setState(null)} /> : null,
  }
}
